import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { TextField, Typography } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useStore } from '../../store';
import { HomeMainContainer } from '../Home/style';
import {
  DashboardContainer,
  DashboardContent,
  DashboardTime,
  DashboardTitle,
  DashboardCount,
  ProgressImage,
  DashboardChartContainer,
  DashboardChartContent,
} from './style';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

/* eslint-disable @typescript-eslint/no-unused-vars */

export default observer(() => {
  const {
    dashboardStore: {
      latestDate,
      userCount,
      sectionLabels,
      sectionValue,
      userUpdate,
      isLoading,
      isChartLoading,
      chartData,
      updateChartData,
    },
  } = useStore();
  const useerLabel: any = {
    TOTAL: 'Members',
    ACTIVATED: 'Activated Memebers',
    DELETED: 'Deleted Members',
    SUSPENDED: 'Suspended Members',
    TO_BE_DELETED_BY_USER: 'To be deleted Members (by Member)',
    TO_BE_DELETED_BY_ADMIN: 'To be deleted Members (by Admin)',
  };
  const [startDate, setStartDate] = useState<Date | null>(() => {
    const today = dayjs();
    const oneWeekAgo = today.subtract(7, 'day').toDate();
    return oneWeekAgo;
  });
  const [endDate, setEndDate] = useState<Date | null>(() => {
    const today = dayjs();
    return today.toDate();
  });
  useEffect(() => {
    userUpdate();
  }, [userUpdate]);

  useEffect(() => {
    if (startDate && endDate) {
      updateChartData(startDate, endDate);
    }
  }, [startDate, endDate, updateChartData]);

  console.log('chartData', chartData);
  
  return (
    <HomeMainContainer>
      {latestDate !== '' && (
        <DashboardTime>
          The value is effective until: {latestDate} (UTC)
        </DashboardTime>
      )}
      <DashboardContainer style={{ borderBottom: '1px solid #ddd' }}>
        {userCount.users.map((user: any) => (
          <DashboardContent key={user.name}>
            <DashboardTitle>{useerLabel[user.name]}</DashboardTitle>
            {!isLoading && (
              <DashboardCount>{user.count.toLocaleString()}</DashboardCount>
            )}
            {isLoading && (
              <DashboardCount className="progress">
                <ProgressImage />
              </DashboardCount>
            )}
          </DashboardContent>
        ))}
      </DashboardContainer>
      {/* <div style={{ height: '1px', backgroundColor: '#000' }} /> */}
      <DashboardContainer className="badges">
        {userCount.badges.map((badge: any) => (
          <DashboardContent key={badge.name}>
            <DashboardTitle>
              <img src={badge.image} alt={badge.name} />
              <p>{badge.name.replaceAll('_', ' ')}</p>
            </DashboardTitle>
            {!isLoading && (
              <DashboardCount>{badge.count.toLocaleString()}</DashboardCount>
            )}
            {isLoading && (
              <DashboardCount className="progress">
                <ProgressImage />
              </DashboardCount>
            )}
          </DashboardContent>
        ))}
      </DashboardContainer>
      <DashboardChartContainer>
        <DashboardTitle>New Users and Youtube channel registrations</DashboardTitle>
        {/* Date range picker UX using MUI v5.4.3 components */}
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', margin: '16px 0' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <span style={{ margin: '0 8px', fontSize: '14px', fontWeight: '500' }}>From</span>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
            <span style={{ margin: '0 8px', fontSize: '14px', fontWeight: '500' }}>To</span>
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        {/* Show total whitelist count field */}
        {!isChartLoading && (
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#222' }}>
              <b>Total whitelist count: {chartData.totalWhitelistCount?.toLocaleString?.() ?? 0}</b>
            </span>
        </div>
        )}
        </div>
        <DashboardChartContent>
          {isChartLoading && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <ProgressImage />
            </div>
          )}
          {!isChartLoading && chartData.labels.length > 0 && (
          <Bar
            data={{
              labels: chartData.labels,
              datasets: [
                {
                  label: 'Newbies',
                  data: chartData.datasets[0].newbies,
                  backgroundColor: 'rgba(224, 203, 15, 0.72)',
                },
                {
                  label: 'Youtube channel registration',
                  data: chartData.datasets[1].youtubeChannelRegistration,
                  backgroundColor: 'rgba(235, 8, 38, 0.81)',
                }
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: true,
              plugins: {
                legend: { position: 'top' as const },
                title: { display: true, text: 'Newbies and Youtube channel registration' },
                },
              }}
            />
          )}
        </DashboardChartContent>
      </DashboardChartContainer>
      
    </HomeMainContainer>
  );
});
